import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, Form } from 'react-bootstrap';
import Select from 'react-select';
import { MinusPlusInput } from './MinusPlusInput';

export const Garages = ({ handleChangeCaracObj, values, errors, touched }) => {
  const optionsCover = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'Cubierta' },
    { value: 2, label: 'Descubierta' },
    { value: 3, label: 'Semi-cubierta' }
  ];
  const optionsUbication = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'PB' },
    { value: 2, label: 'Subsuelo' },
    { value: 3, label: 'En altura' }
  ];

  return (
    <div>
      <Form.Group className="d-flex gap-2 align-items-center">
        <Form.Check
          type="checkbox"
          onChange={e => {
            handleChangeCaracObj('garages.active', e.target.checked);
            if (!e.target.checked) {
              handleChangeCaracObj('garages.cover', '');
              handleChangeCaracObj('garages.ubication', '');
              handleChangeCaracObj('garages.quantity', '');
            } else {
              handleChangeCaracObj('garages.quantity', 1);
            }
          }}
          checked={values?.active || false}
        />

        <Form.Label className="m-0">Cocheras</Form.Label>
      </Form.Group>

      <Collapse in={values?.active}>
        <div className="mt-2">
          <Form.Group>
            <Form.Label>Cobertura</Form.Label>
            <Select
              value={optionsCover.find(
                option => option.value === values?.cover
              )}
              options={optionsCover}
              onChange={option =>
                handleChangeCaracObj(
                  'garages.cover',
                  option?.value && Number(option.value)
                )
              }
              isSearchable={false}
              name="characteristics.garages.cover"
            />

            {errors?.cover && touched?.cover && (
              <label className="w-100 text-danger">{errors.cover}</label>
            )}
          </Form.Group>
          <Form.Group>
            <Form.Label>Ubicación</Form.Label>
            <Select
              value={optionsUbication.find(
                option => option.value === values?.ubication
              )}
              options={optionsUbication}
              onChange={option =>
                handleChangeCaracObj(
                  'garages.ubication',
                  option?.value && Number(option.value)
                )
              }
              isSearchable={false}
              name="characteristics.garages.ubication"
            />

            {errors?.ubication && touched?.ubication && (
              <label className="w-100 text-danger">{errors.ubication}</label>
            )}
          </Form.Group>

          <MinusPlusInput
            noCenter
            handleChangeCarac={(e, name, action) => {
              if (action === 'rest' && values.quantity === 1) return;

              handleChangeCaracObj(
                name,
                action === 'add'
                  ? (values.quantity || 0) + 1
                  : (values.quantity || 0) - 1
              );
            }}
            name="garages.quantity"
            quantity={values?.quantity || 0}
            title="Cantidad"
          />
        </div>
      </Collapse>
    </div>
  );
};

Garages.propTypes = {
  handleChangeCaracObj: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object
};
